import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import Timeout from "await-timeout";
import { handleErrors } from "../../../services/handleErrors";
import { LabSelect } from "../../../components/course/select";
import { CustomLabel } from "../../../ui/labels";
import { ButtonPrimary } from "../../../ui/buttons";

const MultiAsociateCandidatesNPs = ({ toggle, isOpen, info, handleMultiEditCandidatos, notasDePedidoActivas, isLoading }) => {
  const [notaDePedidoValue, setNotaDePedidoValue] = useState(null);

  const notasDePedidoOptions = notasDePedidoActivas
    ? notasDePedidoActivas
        .map((e) => {
          return { label: `${e.razonSocial}-${e.cargo}-${e.id}`, value: e.id };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];
  function getFunctionToFilter(filter, selected) {
    if (filter === "notaDePedidoId") {
      setNotaDePedidoValue(selected);
    }
  }
  const handleReactSelectChange = (selected, options) => {
    const filtro = options.name;
    getFunctionToFilter(filtro, selected);
  };
  const formik = useFormik({
    initialValues: {
      idsCandidatos: [],
      notaDePedidoId: "",
    },
    onSubmit: async (values) => {
      const dataToEdit = {
        ...values,
        idsCandidatos: info.map((e) => e.candidatoId),
        notaDePedidoId: notaDePedidoValue && notaDePedidoValue.value,
      };

      try {
        handleMultiEditCandidatos(dataToEdit);
        await Timeout.set(1000);
        toggle();
      } catch (error) {
        handleErrors(error, toast.error, null, formik);
      }
    },
  });

  return (
    <div>
      <Modal isOpen={isOpen} centered style={{ fontFamily: "Nunito" }}>
        <ModalHeader toggle={toggle} style={{ borderBottom: "none", background: " #f8f8f8" }}>
          Editar candidatos
        </ModalHeader>
        <ModalBody style={{ background: " #f8f8f8" }}>
          <form className="theme-form" onSubmit={formik.handleSubmit}>
            <div className="row" style={{ display: "flex", justifyContent: "center" }}>
              {/* <div className="col-md-12"> */}
              <CustomLabel htmlFor="notaDePedidoId-select" className="pt-0 w-100">
                Notas de pedido
                <LabSelect
                  id="notaDePedidoId-select"
                  name="notaDePedidoId"
                  className="w-100"
                  onChange={handleReactSelectChange}
                  value={notaDePedidoValue || null}
                  placeholder="Seleccionar..."
                  isClearable
                  isLoading={isLoading}
                  isDisabled={isLoading}
                  options={notasDePedidoOptions}
                />
              </CustomLabel>
            </div>
            {/* </div> */}

            <div className=" mt-3 mb-0 d-flex justify-content-end align-items-end">
              <Button color="btn-secondary mr-2" style={{ height: "40px" }} onClick={toggle}>
                Cancelar
              </Button>
              <ButtonPrimary disabled={formik.isSubmitting} fontSize="14px" type="submit">
                Asociar candidatos
              </ButtonPrimary>
            </div>
          </form>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default MultiAsociateCandidatesNPs;
